<template>
    <div id="tab4" class="content easein surrounding" :class="{ 'easein-active': opacitys }">
        <div class="split-title easein" :class="{ 'easein-active': opacitys }">
            <div class="line"></div>
            {{ desc.products.configName }}
            <div class="line"></div>
        </div>
        <div class="split-desc easein" :class="{ 'easein-active': opacitys }">
            {{ desc.products.configContent }}
        </div>
        <div class="surrounding-banner">
            <swiper ref="swiper" :options="surroundingSwiperOptions">
                <swiper-slide v-for="(items, index) in surrounding" :key="index">
                    <a :href="items.linkUrl" target="_blank" class="broadcast-item">
                        <el-image :src="items.linkImg" />
                    </a>
                </swiper-slide>
            </swiper>
            <div class="swiper-pagination"></div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Surrounding',
    props: {
        opacitys: {
            type: Boolean,
            default: false,
        },
        surrounding: {
            type: Array,
            default: () => [],
        },
        desc: {
            type: Object,
            default: () => {},
        },
    },
    computed: {
        swiper() {
            return this.$refs.swiper.$swiper
        },
    },
    data: function () {
        return {
            surroundingSwiperOptions: {
                autoplay: true,
                loop: true,
                pagination: {
                    el: '.swiper-pagination',
                },
            },
        }
    },
    mounted() {
        this.$nextTick(() => {
            this.swiper.el.onmouseover = () => {
                this.swiper.autoplay.stop()
            }
            this.swiper.el.onmouseout = () => {
                this.swiper.autoplay.start()
            }
        })
    },
}
</script>

<style lang="scss">
.surrounding {
    .surrounding-banner {
        width: 1600px;
        height: 800px;
        margin: 0 auto;
        margin-top: 60px;
        position: relative;
        a {
            width: 100%;
            height: 800px;
        }
        .el-image {
            width: 100%;
            height: 800px;
            object-fit: cover;
        }
    }
}
</style>
